export default "__VITE_ASSET__754ea49b__"